import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import Field from 'redux-form/lib/Field';
import reduxForm from 'redux-form/lib/reduxForm';
import formValueSelector from 'redux-form/lib/formValueSelector';

import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Button from 'react-bootstrap/lib/Button';
import InputFieldComponent from '../../Common/FormField/InputFieldComponent';
import SelectFieldComponent from '../../Common/FormField/SelectFieldComponent';

import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import submit from './submit';
import validate from './validate';

import messages from '../../../locale/messages';

import Recaptcha from './Recaptcha';

import bt from '../../../components/commonStyle.css';
import s from './SiteConfigForm.css';
class SiteConfigForm extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    title: PropTypes.string,
  };

  render() {
    const { error, handleSubmit, submitting } = this.props;
    const { formatMessage } = this.props.intl;
    return (
      <div>

        <h1 className={s.siteAdminHeading}><FormattedMessage {...messages.manageSiteConfig} /></h1>
        <form onSubmit={handleSubmit(submit)}>
          {error && <strong>{error}</strong>}

          <p className={s.siteAdminSubHeading}>{formatMessage(messages.stripeAccountSettings)}</p>

          <div className={s.girdOne}>
            <Field name="stripeSecretKey"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.stripeSecretKey)}
              inputClass={bt.commonControlInput}
              formGroupClass={bt.space4}
              infoText={formatMessage(messages.stripeSecretKeyTooltip)}
              showToolTip={true}
              tipPlacement='bottom'
              placeholder={formatMessage(messages.stripeSecretKeyPlaceHolder)} />

            <Field name="stripePublishableKey"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.stripePublishableKey)}
              inputClass={bt.commonControlInput}
              formGroupClass={bt.space4}
              infoText={formatMessage(messages.stripePublishableKeyTooltip)}
              showToolTip={true}
              tipPlacement='bottom'
              placeholder={formatMessage(messages.stripePublishableKeyPlaceHolder)} />
          </div>

          <div className={s.adminFormDivider} />

          <p className={s.siteAdminSubHeading}>{formatMessage(messages.payPalAccountSettings)}</p>
          <div className={s.girdTwo}>
            <Field name="paypalClientId"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.paypalClientId)}
              inputClass={bt.commonControlInput}
              formGroupClass={bt.space4}
              infoText={formatMessage(messages.paypalClientIdTooltip)}
              showToolTip={true}
              placeholder={formatMessage(messages.paypalClientIdPlaceHolder)} />

            <Field name="paypalSecret"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.paypalSecret)}
              inputClass={bt.commonControlInput}
              formGroupClass={bt.space4}
              infoText={formatMessage(messages.paypalSecretKeyTooltip)}
              showToolTip={true}
              placeholder={formatMessage(messages.paypalSecretPlaceHolder)} />

            <Field name="paypalHost"
              type="text"
              component={SelectFieldComponent}
              label={formatMessage(messages.paypalHost)}
              inputClass={cx(bt.commonControlSelect, 'commonControlSelectRtl')}
              formGroupClass={bt.space4}
              infoText={formatMessage(messages.paypalHostTooltip)}
              showToolTip={true}
              options={[
                { value: "https://api-m.sandbox.paypal.com", label: 'https://api-m.sandbox.paypal.com (Sandbox)' },
                { value: "https://api-m.paypal.com", label: 'https://api-m.paypal.com (Live)' },
              ]}
            />
          </div>

          <div className={s.adminFormDivider} />
          <p className={s.siteAdminSubHeading}>{formatMessage(messages.twilioSmsSettings)}</p>

          <div className={s.girdTwo}>
            <Field name="twillioAccountSid"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.twillioAccountSid)}
              inputClass={bt.commonControlInput}
              formGroupClass={bt.space4}
              infoText={formatMessage(messages.twilioAccountTooltip)}
              showToolTip={true}
              placeholder={formatMessage(messages.twilioAccountSidPlaceHolder)} />

            <Field name="twillioAuthToken"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.twillioAuthToken)}
              inputClass={bt.commonControlInput}
              formGroupClass={bt.space4}
              infoText={formatMessage(messages.twilioAuthTooltip)}
              showToolTip={true}
              placeholder={formatMessage(messages.twilioAuthTokenPlaceHolder)} />

            <Field name="twillioPhone"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.twillioPhone)}
              inputClass={bt.commonControlInput}
              formGroupClass={bt.space4}
              infoText={formatMessage(messages.twilioPhoneNumberTooltip)}
              showToolTip={true}
              placeholder={formatMessage(messages.twilioPhonePlaceHolder)} />
          </div>

          <div className={s.adminFormDivider} />
          <p className={s.siteAdminSubHeading}>{formatMessage(messages.googleApiCredentials)}</p>
          <div className={s.girdOne}>
            <Field name="googleClientId"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.googleClientId)}
              inputClass={bt.commonControlInput}
              formGroupClass={bt.space4}
              infoText={formatMessage(messages.googleClientIdTooltip)}
              showToolTip={true}
              placeholder={formatMessage(messages.googleClientIdPlaceHolder)} />

            <Field name="googleSecretId"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.googleSecretId)}
              inputClass={bt.commonControlInput}
              formGroupClass={bt.space4}
              infoText={formatMessage(messages.googleSecretIdTooltip)}
              showToolTip={true}
              placeholder={formatMessage(messages.googleSecretIdPlaceHolder)} />
          </div>

          <div className={s.adminFormDivider} />

          <Recaptcha />

          <div className={s.adminFormDivider} />

          <p className={s.siteAdminSubHeading}>{formatMessage(messages.webGoogleApiKeys)}</p>

          <div className={s.girdOne}>
            <Field name="googleMapBrowserApiKey"
              type="text" component={InputFieldComponent}
              label={formatMessage(messages.googleMapBrowserApiKey)}
              inputClass={bt.commonControlInput}
              formGroupClass={bt.space4}
              showToolTip
              infoText={formatMessage(messages.googleMapBrowserApiKeyTooltip)}
              placeholder={formatMessage(messages.googleMapBrowserApiKeyPlaceHolder)} />

            <Field name="googleMapServerApiKey"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.googleMapServerApiKey)}
              inputClass={bt.commonControlInput}
              formGroupClass={bt.space4}
              showToolTip
              infoText={formatMessage(messages.googleMapServerApiKeyTooltip)} placeholder={formatMessage(messages.googleMapServerApiKeyPlaceHolder)} />
          </div>

          <div className={s.adminFormDivider} />

          <p className={s.siteAdminSubHeading}>{formatMessage(messages.mobileGoogleApiKeys)}</p>

          <div className={s.girdOne}>
            <Field name="androidMapApiKey"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.androidMapApiKey)}
              inputClass={bt.commonControlInput}
              formGroupClass={bt.space4}
              showToolTip infoText={formatMessage(messages.androidMapApiKeyTooltip)}
              placeholder={formatMessage(messages.androidMapApiKeyPlaceHolder)} />

            <Field name="iosMapApiKey"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.iosMapApiKey)}
              inputClass={bt.commonControlInput}
              formGroupClass={bt.space4}
              showToolTip
              infoText={formatMessage(messages.iosMapApiKeyTooltip)}
              placeholder={formatMessage(messages.iosMapApiKeyPlaceHolder)} />
          </div>

          <div className={s.adminFormDivider} />
          <p className={s.siteAdminSubHeading}>{formatMessage(messages.deepLinkSettings)}</p>
          <div className={s.girdOne}>
            <Field name="deepLinkBundleId"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.deepLinkBundleId)}
              inputClass={bt.commonControlInput}
              formGroupClass={bt.space4}
              infoText={formatMessage(messages.deepLinkIdTooltip)}
              showToolTip={true}
              placeholder={formatMessage(messages.deepLinkBundleIdPlaceHolder)} />
            <Field
              name="deepLinkContent"
              component={InputFieldComponent}
              componentClass={"textarea"}
              inputClass={bt.commonControlTextArea}
              formGroupClass={bt.space4}
              label={formatMessage(messages.deepLinkContent)}
              infoText={formatMessage(messages.deepLinkJSONTooltip)} showToolTip={true}
              placeholder={formatMessage(messages.deepLinkContentPlaceHolder)}
            />
          </div>

          <div className={s.adminFormDivider} />

          <p className={s.siteAdminSubHeading}>{formatMessage(messages.pushNotificationSettings)}</p>
          <div className={s.girdOne}>
            <Field name="fcmPushNotificationKey"
              component={InputFieldComponent}
              label={formatMessage(messages.fcmPushNotificationKey)}
              inputClass={bt.commonControlTextArea}
              formGroupClass={bt.space4}
              componentClass={"textarea"}
              infoText={formatMessage(messages.pushNotificationKeyTooltip)}
              showToolTip={true}
              placeholder={formatMessage(messages.fcmPushNotificationKeyPlaceHolder)} />
          </div>

          <div className={s.adminFormDivider} />

          <p className={s.siteAdminSubHeading}>{formatMessage(messages.otherSettings)}</p>
          <div className={s.girdOne}>
            <Field name="maxUploadSize"
              type="text"
              component={InputFieldComponent}
              label={formatMessage(messages.maxUploadLabel)}
              inputClass={bt.commonControlInput}
              formGroupClass={bt.space4}
              infoText={formatMessage(messages.maximumImageUploadTooltip)}
              showToolTip={true}
              placeholder={formatMessage(messages.maxUploadPlaceHolder)} />
          </div>

          <div className={s.adminFormDivider} />

          <div className='singleButtonFlexEnd'>
            <Button className={cx(bt.btnPrimary, bt.btnLarge)} type="submit" disabled={submitting} >
              <FormattedMessage {...messages.save} />
            </Button>
          </div>
        </form>
      </div>
    );
  }
}


SiteConfigForm = reduxForm({
  form: 'SiteConfigForm', // a unique name for this form
  validate
})(SiteConfigForm);

const selector = formValueSelector('SiteConfigForm');

const mapState = (state) => ({
  homePageType: selector(state, 'homePageType'),
  appAvailableStatus: selector(state, 'appAvailableStatus')
});

const mapDispatch = {};

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(SiteConfigForm)));